import { render, staticRenderFns } from "./order_detail.vue?vue&type=template&id=5309c19a&scoped=true"
import script from "./order_detail.vue?vue&type=script&lang=js"
export * from "./order_detail.vue?vue&type=script&lang=js"
import style0 from "./order_detail.vue?vue&type=style&index=0&id=5309c19a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5309c19a",
  null
  
)

export default component.exports